// app-pages/OTPPage.tsx
"use client";
import { Flex, Spinner, Text } from "@chakra-ui/react";
import { useRouter } from "next/navigation";
import { emailSignUp } from "queries";
import { useAppContext } from "hooks";
import { useEffect, useState } from "react";
import { ConsentModal } from "components";

export const OTPPage = ({ otp = "" }: { otp?: string }) => {
  const { setJwt } = useAppContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [requestMessage, setRequestMessage] = useState<string>("");
  const [consentModalIsOpen, setConsentModalIsOpen] = useState<boolean>(false);
  const [nsfwConsent, setNsfwConsent] = useState(true);
  const [newsletterConsent, setNewsletterConsent] = useState(false);
  const [adultConsent, setAdultConsent] = useState(false);
  const router = useRouter();
  
  useEffect(() => {
    if (otp) {
      setIsLoading(true);
      emailSignUp({
        otp_encrypted: otp,
        newsletter_consent: newsletterConsent,
        adult_consent: adultConsent,
        nsfw_consent: false, //nsfwConsent,
      })
        .then((data: any) => {
          setJwt(data.encoded_jwt);
          setRequestMessage("Logged in successfully, you will be redirected soon");
          router.push("/");
          setIsLoading(false);
        })
        .catch((error: any) => {
          console.log(error)
          if (error?.detail === "ConsentRequired") {
            setConsentModalIsOpen(true);
          }

          console.log(error.detail);
          setIsLoading(false);
          setRequestMessage("This link looks invalid, please try again");
        });
    } else {
      router.replace("/");
    }
  }, [otp, adultConsent]);

  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      h="100vh"
      w="100vw"
      direction="column"
      visibility={otp ? "visible" : "hidden"}
      justifyContent="center"
      alignItems="center"
      bg="#16181F"
    >
      <ConsentModal
        isOpen={consentModalIsOpen}
        onConsentChange={{ setNsfwConsent, setNewsletterConsent, setAdultConsent }}
        onClose={() => setConsentModalIsOpen(false)}
      />
      {isLoading && <Spinner />}
      <Text>{isLoading ? "Logging in, please wait a second" : requestMessage}</Text>
    </Flex>
  );
};

export default OTPPage;
